module.exports = __webpack_public_path__ + "img/car_logo.6b57d2a6.png";